import GradeTableForOffice from './GradeTableForOffice';
export default GradeTableForOffice;
